module.exports = __webpack_public_path__ + "img/communication9.3bc2929a.png";